export interface JourneyCardCta {
  label: 'Bloqueada' | 'Concluída' | 'Refazer' | 'Iniciar' | 'Continuar'
  variant: 'primary' | 'success'
  /** CTA não interativo (não navega). */
  disabled: boolean
  /** Verde apagado: mantém a cor da variante, esmaecida (não usa o cinza do disabled nativo). */
  muted: boolean
}

export function getJourneyCardCta(params: {
  blocked: boolean
  finished: boolean
  blockRedo: boolean
  started: boolean
}): JourneyCardCta {
  if (params.blocked) {
    return { label: 'Bloqueada', variant: 'primary', disabled: true, muted: false }
  }

  if (params.finished) {
    if (params.blockRedo) {
      return { label: 'Concluída', variant: 'success', disabled: true, muted: true }
    }
    return { label: 'Refazer', variant: 'success', disabled: false, muted: false }
  }

  if (!params.started) {
    return { label: 'Iniciar', variant: 'primary', disabled: false, muted: false }
  }

  return { label: 'Continuar', variant: 'primary', disabled: false, muted: false }
}
